import { render, staticRenderFns } from "./Rischi_Tab4.vue?vue&type=template&id=625b5a5a&scoped=true&"
import script from "./Rischi_Tab4.vue?vue&type=script&lang=js&"
export * from "./Rischi_Tab4.vue?vue&type=script&lang=js&"
import style0 from "./Rischi_Tab4.vue?vue&type=style&index=0&id=625b5a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625b5a5a",
  null
  
)

export default component.exports